export default {
  type: 'doc',
  content: [
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        { text: 'Work Description', type: 'text', marks: [{ type: 'bold' }] },
      ],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              content: [{ text: 'Scope of Work:', type: 'text' }],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              content: [{ text: 'Special Instructions:', type: 'text' }],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [{ text: 'Team', type: 'text', marks: [{ type: 'bold' }] }],
    },
    {
      type: 'bulletList',
      content: [
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Project Owner: {{currentUser.name}}',
                  type: 'text',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Assigned Users: {{project.projectUsers}}',
                  type: 'text',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              content: [
                {
                  text: 'Total Number of Workers: {{project.projectUsersCount}}',
                  type: 'text',
                },
              ],
            },
          ],
        },
        {
          type: 'listItem',
          content: [
            {
              type: 'paragraph',
              content: [{ text: 'Work Hours:', type: 'text' }],
            },
          ],
        },
      ],
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        {
          text: 'Materials and Equipment',
          type: 'text',
          marks: [{ type: 'bold' }],
        },
      ],
    },
    {
      type: 'orderedList',
      attrs: { start: 1 },
      content: [{ type: 'listItem', content: [{ type: 'paragraph' }] }],
    },
    {
      type: 'heading',
      attrs: { level: 2 },
      content: [
        { text: 'Reference Photos', type: 'text', marks: [{ type: 'bold' }] },
      ],
    },
    {
      type: 'paragraph',
      content: [
        {
          text: '\u003cTake or add photos from the project here\u003e',
          type: 'text',
          marks: [{ type: 'italic' }],
        },
      ],
    },
    { type: 'paragraph' },
  ],
};
